import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { dataType } from '../../../constants/data-type';
import "@/assets/styles/components/my-account/currency-balance.mobile.scss";
import { getSafe } from '../../../helpers/global';
import { Converter, formatFunctions } from '../../../helpers/functions';

class AccountBalanceMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      detailsList: props.detailsList,
      selectCurrencyID: ''
    }
  }

  onExpandItem(item) {
    let detailsList = this.state.detailsList.map(t => {
      if(t.currencyID === item.currencyID) {
        t.isExpand = !t.isExpand;
        return t
      }
    })
    this.setState({ detailsList: detailsList })
  }

  componentDidUpdate(prevProps) {
    if (this.props.detailsList !== prevProps.detailsList) {
      this.setState({ 
        detailsList: this.props.detailsList,
        selectCurrencyID: this.props.detailsList[0].currencyID
      })
    }
  }

  render() {
    const { language } = this.props;
    const { detailsList,selectCurrencyID } = this.state;
    return (
      <React.Fragment>
        <div className="cash-account-container-mobile">
          <div className='cash-account-currency'>
            {detailsList.map(item => {
              if(item.currencyID){
                return(
                  <div onClick={() => this.setState({selectCurrencyID: item.currencyID})} 
                    key={item.currencyID} 
                    className={classnames('cash-account-currency-item',selectCurrencyID === item.currencyID && 'currenct-select')}>
                      {item.currencyID}
                  </div>
                )
              }
            })}
          </div>
          <div className='cash-account-details'>
            {detailsList.map(item => {
              if(item.currencyID === selectCurrencyID){
                return(
                  <React.Fragment key={item.currencyID}>
                    <div className='cash-account-details-item'>
                      <span>{getSafe(() => language.current_account_buying_power)}</span>
                      <span>{formatFunctions.dataFormat(item.buyingPower, dataType.CASH)}</span>
                    </div>
                    <div className='cash-account-details-item'>
                      <span>{getSafe(() => language.common_due_balance)}</span>
                      <span>{formatFunctions.dataFormat(item.dueBalance, dataType.CASH)}</span>
                    </div>
                    <div className='cash-account-details-item'>
                      <span>{getSafe(() => language.current_account_settled_balance)}</span>
                      <span>{formatFunctions.dataFormat(item.settledBalance, dataType.CASH)}</span>
                    </div>
                    <div className='cash-account-details-item'>
                      <span>{getSafe(() => language.current_account_withdrawable_balance)}</span>
                      <span>{formatFunctions.dataFormat(item.withdrawableBalance, dataType.CASH)}</span>
                    </div>
                    <div className='cash-account-details-item'>
                      <span>{getSafe(() => language.current_account_ledger_balance)}</span>
                      <span>{formatFunctions.dataFormat(item.ledgerBalance, dataType.CASH)}</span>
                    </div>
                  </React.Fragment>
                )
              }
            })}
          </div>
        </div>
      </React.Fragment>
    )
  }

}

AccountBalanceMobile.defaultProps = {
  detailsList: []
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(AccountBalanceMobile)